var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "cake_brands_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { staticClass: "type_wrap", attrs: { prop: "type" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 选择类型 ")]),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "type", $$v)
                    },
                    expression: "value.config.type",
                  },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "type_box" },
                    [
                      _c("el-image", {
                        class: [
                          "img",
                          _vm.value.config.type === item.id && "active",
                        ],
                        attrs: { src: item.imageurl, fit: "contain" },
                        on: {
                          click: function ($event) {
                            return _vm.changeType(item.id)
                          },
                        },
                      }),
                      _c("el-radio", { attrs: { label: item.id } }, [
                        _vm._v(_vm._s(item.label)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "name",
            rules:
              _vm.value.config.type === 1
                ? [
                    {
                      required: true,
                      message: "组件名称不可为空",
                      trigger: "change",
                    },
                    {
                      min: 1,
                      max: 10,
                      message: "标题字数应大于等于1个字符小于10个字符!",
                      trigger: "change",
                    },
                  ]
                : [],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("组件名称")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "addFormItem", attrs: { prop: "show_title_icon" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("是否显示标题旁边图标")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.show_title_icon,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "show_title_icon", $$v)
                },
                expression: "value.config.show_title_icon",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [_c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")])],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [_c("el-radio", { attrs: { label: 0 } }, [_vm._v("不显示")])],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.value.config.type === 2
        ? [
            _c(
              "el-form-item",
              { staticClass: "addFormItem", attrs: { prop: "bg_style" } },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("组件边框和背景色"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.bg_style,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "bg_style", $$v)
                      },
                      expression: "value.config.bg_style",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("无边框，背景色跟页面一致"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("有边框，独立设置背景色"),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.value.config.bg_style === 2
              ? [
                  _c(
                    "el-form-item",
                    { staticClass: "addFormItem", attrs: { prop: "bg_color" } },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("背景色")]),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.value.config.bg_color,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "bg_color", $$v)
                          },
                          expression: "value.config.bg_color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "addFormItem",
                      attrs: { prop: "border_style" },
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("边框显示和隐藏"),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeBorderStyle },
                              model: {
                                value: _vm.value.config.border_style,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.value.config,
                                    "border_style",
                                    $$v
                                  )
                                },
                                expression: "value.config.border_style",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "radio-box" },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("显示全部边框"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "radio-box" },
                                [
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("隐藏部分边框"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "border_none_box",
                              class: _vm.getBorderBoxClass,
                            },
                            _vm._l(4, function (line) {
                              return _c("div", {
                                key: line,
                                class: [
                                  "line",
                                  "line" + line,
                                  _vm.value.config.border_style === 2 &&
                                    "pointer",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.changeLine(line)
                                  },
                                },
                              })
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips hide-border" }, [
                        _vm._v(
                          " 隐藏某条边框时，与之相连的圆角将变为直角，比如隐藏下方边框，左下方和右下方的圆角会变成直角。 "
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm._e(),
            _c(
              "el-form-item",
              { staticClass: "addFormItem", attrs: { prop: "cols" } },
              [
                _c("div", { staticClass: "title" }, [_vm._v("列数")]),
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    " 5列（96*96）用于金刚区独立使用，5列（84*84）用于跟四列金刚区混合使用 "
                  ),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.value.config.cols,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "cols", $$v)
                      },
                      expression: "value.config.cols",
                    },
                  },
                  _vm._l(_vm.colsList, function (col) {
                    return _c("el-option", {
                      key: col.value,
                      attrs: { label: col.label, value: col.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "el-form-item",
        { staticClass: "addFormItem", attrs: { prop: "brand_show_type" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("首页品牌显示模式")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.brand_show_type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "brand_show_type", $$v)
                },
                expression: "value.config.brand_show_type",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("封面品牌显示完后按品牌顺序自动填充"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("仅显示封面品牌"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "category_id" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("点击更多时跳转的菜单")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { filterable: "", placeholder: "选择蛋糕类型的菜单" },
              on: { change: _vm.changeCategory },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  label: item.show_name,
                  value: item.id,
                  disabled: item.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("el-form-item", { staticClass: "brandName" }, [
        _c("div", { staticClass: "label" }, [_vm._v("设置组件封面展示品牌")]),
        _c("div", { staticClass: "tips" }, [
          _vm._v("已添加的封面品牌拖动可排序，点击右上方按钮删除"),
        ]),
        _c(
          "div",
          { staticClass: "add-box" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "value-key": "id",
                  placeholder: "搜索或选择品牌",
                  clearable: "",
                  filterable: "",
                  disabled: !_vm.value.config.category_id,
                },
                model: {
                  value: _vm.bidObj,
                  callback: function ($$v) {
                    _vm.bidObj = $$v
                  },
                  expression: "bidObj",
                },
              },
              _vm._l(_vm.list, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: {
                    label: item.brand_name,
                    value: item,
                    disabled: _vm.value.config.bids.includes(item.id),
                  },
                })
              }),
              1
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.addBrand } },
              [_vm._v("添加到封面")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-form-item",
        { staticClass: "brandList", attrs: { prop: "brandList" } },
        [
          _c(
            "draggable",
            {
              attrs: { animation: "500", "force-fallback": true },
              model: {
                value: _vm.value.config.brandList,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "brandList", $$v)
                },
                expression: "value.config.brandList",
              },
            },
            _vm._l(_vm.value.config.brandList, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  class: {
                    brand: _vm.value.config.type === 1,
                    box: _vm.value.config.type === 2,
                  },
                },
                [
                  _vm.value.config.type === 1
                    ? [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(" " + _vm._s(item.brand_name) + " "),
                        ]),
                        _c("i", {
                          staticClass: "el-icon el-icon-close",
                          on: {
                            click: function ($event) {
                              return _vm.deleteBrand(index)
                            },
                          },
                        }),
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "name-box" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入", disabled: "" },
                              model: {
                                value: item.brand_name,
                                callback: function ($$v) {
                                  _vm.$set(item, "brand_name", $$v)
                                },
                                expression: "item.brand_name",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteBrand(index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "brandList." + index + ".brand_logo",
                              rules: [
                                {
                                  required: true,
                                  message: "品牌图片不可为空",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "upload" },
                              [
                                _c("upload-file", {
                                  ref: "uploadBanner",
                                  refInFor: true,
                                  attrs: {
                                    "link-url": _vm.linkUrl,
                                    tempurl: item.brand_logo,
                                    uploadInfo: _vm.uploadInfo,
                                  },
                                  on: {
                                    emitUploadFile: function (res) {
                                      return _vm.emitUploadFile(res, item)
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "upload-item-wrap" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.onUpload(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" 上传图片 ")]
                                    ),
                                    _vm.pictureList.length > 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectPicture(index)
                                              },
                                            },
                                          },
                                          [_vm._v(" 选择图片 ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "rows", attrs: { prop: "rows" } },
        [
          _c("div", [_vm._v(" 显示的行数 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入显示的行数", clearable: "" },
            model: {
              value: _vm.value.config.rows,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "rows", _vm._n($$v))
              },
              expression: "value.config.rows",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }